module.exports = __webpack_public_path__ + "img/help_6.abda2a09.png";